module.exports = __webpack_public_path__ + "assets/img/27_1347.77162b72.jpg";